export default "__VITE_ASSET__CVVlby7o__"